/* 🤖 this file was generated by svg-to-ts */
export const matIconGppMaybe: {
  name: 'gpp-maybe';
  data: string;
} = {
  name: 'gpp-maybe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 2 4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"/><path d="M11 14h2v2h-2zm0-7h2v5h-2z"/></svg>`
};
